import { yupResolver } from "@hookform/resolvers/yup";
import { registerValidationSchema } from "../../utils/validations/validations";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Axios from "../../utils/Axios";
import { useNavigate } from "react-router-dom";
import { FormRegisterTypes } from "../../interfaces/app_types";

type RegisterFields = FormRegisterTypes & { confirmPassword: string };
const fields: {
  name: keyof RegisterFields;
  label: string;
  type: string;
  placeholder: string;
}[] = [
  {
    name: "username",
    label: "Username",
    type: "text",
    placeholder: "Enter username",
  },
  {
    name: "email",
    label: "Email address",
    type: "email",
    placeholder: "name@company.com",
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Create a password",
  },
  {
    name: "confirmPassword",
    label: "Confirm password",
    type: "password",
    placeholder: "Re-enter password",
  },
];

const RegisterPage = () => {
  const [responseMsg, setResponseMsg] = useState("");
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<RegisterFields>({
    resolver: yupResolver(registerValidationSchema),
  });

  return (
    <section className="register-page" aria-labelledby="register-title">
      <header className="register-heading">
        <p className="login-eyebrow">Team access</p>
        <h1 id="register-title">Create an account</h1>
        <p className="text-muted mb-0">
          Add a team member to the Pressco workspace.
        </p>
      </header>
      <form
        className="register-form"
        noValidate
        onSubmit={handleSubmit(async (data) => {
          setResponseMsg("");
          const formData = new FormData();
          formData.append("username", data.username);
          formData.append("email", data.email);
          formData.append("password", data.password);
          try {
            const res = await Axios.post("/register", formData, {
              headers: { "Content-Type": "application/json" },
            });
            setResponseMsg(res.data.message);
            if (res.data.registered) navigate("/login");
          } catch {
            setResponseMsg("Unable to create the account. Please try again.");
          }
        })}
      >
        <div className="register-fields">
          {fields.map(({ name, label, type, placeholder }) => (
            <div className="register-field" key={name}>
              <label htmlFor={`register-${name}`}>{label}</label>
              <input
                id={`register-${name}`}
                type={type}
                placeholder={placeholder}
                autoComplete={type === "password" ? "new-password" : "off"}
                {...register(name)}
                aria-invalid={!!errors[name]}
                aria-describedby={`register-${name}-error${
                  name === "password" ? " register-password-hint" : ""
                }`}
              />
              {name === "password" && (
                <small id="register-password-hint" className="text-muted">
                  Use at least 8 characters, including uppercase, lowercase and
                  a number.
                </small>
              )}
              <div id={`register-${name}-error`} className="text-danger">
                {errors[name]?.message}
              </div>
            </div>
          ))}
        </div>
        {responseMsg && (
          <p className="text-danger mt-3 mb-0" role="alert">
            {responseMsg}
          </p>
        )}
        <div className="register-actions">
          <button
            type="submit"
            className="styled-btn--dark"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Creating account…" : "Create account"}
          </button>
          <button
            type="button"
            className="styled-btn--std"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </form>
    </section>
  );
};
export default RegisterPage;
